module.exports = __webpack_public_path__ + "img/mec.723438b7.jpg";